import { tv } from 'tailwind-variants'

export const list = tv({
  slots: {
    container: 'p-2',
    title: 'p-2 text-xs uppercase tracking-tight text-neutral-secondary',
  },
})
